import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { StepCard } from '@/components/step-card';
import { CircleCheckIcon } from '@/pages/home/steps/circle-check-icon';
import { EVENT } from '@/common/constants';
import { useEventAgent } from '@/common/hooks/useEventAgent';

import MembershipEmptyStateEdit from '@/common/icons/MembershipEmptyStateEdit.svg';

const OcrCustomError = ({ onRetry }: { onRetry: () => void }) => {
  const { t } = useTranslation();
  const { trackEventWithDedup } = useEventAgent();
  const reasonsTranslation = t('orcCustomError.reasons', { returnObjects: true }) as string[] || [];

  useEffect(() => {
    trackEventWithDedup(EVENT.NOTIFICATION_OCR_ERROR_VIEW);
  }, []);

  const handleRetry = () => {
    trackEventWithDedup(EVENT.NOTIFICATION_ERROR_RETRY_CLICK);
    onRetry();
  };

  return (
    <div className="p-4">
      <StepCard
        icon={MembershipEmptyStateEdit}
        title={t('orcCustomError.title')}
        buttonText={t('common.button.tryAgain')}
        onButtonClick={handleRetry}
      >
        <>
          <p className="mb-4">{t('orcCustomError.intro')}</p>
          <ul>
            {reasonsTranslation.map((error, index) => (
              <li key={index} className="mb-4 flex">
                <CircleCheckIcon />
                {error}
              </li>
            ))}
          </ul>
        </>
      </StepCard>
    </div>
  );
};

export default OcrCustomError;
